import React, { useEffect } from "react";
import useStyles from "./style";
import { Controller } from "react-hook-form";
import {
  Select,
  Input,
  Chip,
  ListItemText,
  Checkbox,
  MenuItem,
  Tooltip,
} from "@material-ui/core";
import { renderErrorCreatePool } from "../../utils/validate";

const countries = require("../../pages/PoolCreate/Components/ForbiddenCountry/countries.json");

function StakeForbiddenCountries({
  setValue,
  errors,
  poolDetail,
  control,
}: any) {
  const classes = useStyles();

  useEffect(() => {
    const source = poolDetail?.stake_forbidden_countries;
    if (Array.isArray(source) && source.length > 0) {
      const normalized = source.map((c: any) =>
        typeof c === "string" ? c : c.code || c.country
      );
      setValue("stake_forbidden_countries", normalized);
    }
  }, [poolDetail?.stake_forbidden_countries, setValue]);

  return (
    <div>
      <div className={classes.formControl}>
      <Tooltip title="Only users who have staked are allowed to participate in the pool. However, users from these countries can only participate if they have an active stake. Once their stake expires, they will no longer be eligible to join the pool."
          placement="top-start"
          style={{
            fontSize: '16px'
          }}
        >

          <label className={classes.formControlLabel}>
            Stake Forbidden Countries
          </label>
        </Tooltip>
        <Controller
          control={control}
          name="stake_forbidden_countries"
          defaultValue={[
            "AFG",
            "DZA",
            "ASM",
            "BHR",
            "BGD",
            "BOL",
            "BWA",
            "CAF",
            "PRK",
            "EGY",
            "GUM",
            "JPN",
            "KWT",
            "LBY",
            "MYS",
            "MAR",
            "NPL",
            "NGA",
            "PAK",
            "PRI",
            "QAT",
            "SGP",
            "ZAF",
            "KOR",
            "SSD",
            "THA",
            "TTO",
            "TUN",
            "ARE",
            "VIR",
            "UZB",
            "VEN",
            "YEM",
          ]}
          render={(field) => (
            <Select
              className={classes.formControlInput}
              multiple
              value={field.value}
              onChange={field.onChange}
              input={<Input />}
              renderValue={(value: any) => (
                <div>
                  {value.map((val: any) => (
                    <Chip
                      key={val}
                      label={val}
                      style={{ marginRight: ".5rem" }}
                    />
                  ))}
                </div>
              )}
            >
              {countries.map((country: any) => (
                <MenuItem key={country.code} value={country.code}>
                  <Checkbox checked={field.value.includes(country.code)} />
                  <ListItemText primary={country.name} />
                </MenuItem>
              ))}
            </Select>
          )}
        />
        <p className={classes.formErrorMessage}>
          {renderErrorCreatePool(errors, "stake_forbidden_countries")}
        </p>
      </div>
    </div>
  );
}

export default StakeForbiddenCountries;
